import { useReactiveVar } from '@apollo/client'

import { routingVar } from 'src/reactive-variables/routing'

import { useMe } from './useMe'

/**
 * Per-company gate for Route Studio (D01: free at launch, D33: the
 * company-settings flag stays for staged rollout).
 *
 * Reads `CompanySettingsType.routeStudioEnabled` from the `me` payload
 * (`GetMeByProjectIds`, `src/api/auth.ts`). This hook is the single
 * source of truth for the flag on the frontend: the sidebar entry
 * (`NavigationMenu`) and the module's route gate
 * (`src/modules/route-studio/routing/index.tsx`) both read it, so a
 * flag-off company neither discovers the module nor reaches it by
 * direct URL.
 *
 * PRO-218: contractor (hauler) logins read as OFF regardless of the
 * company flag — mirroring the backend's single choke point
 * (`route_studio/access.py`, `route_studio_enabled_for_user`), which
 * denies hauler users on every resolver because Route Studio is an
 * office-only planning surface over company-wide commercial data.
 * Without the mirror, contractors got a sidebar entry and a module
 * shell where every query failed with "Route Studio is not enabled
 * for this company".
 */
export const useRouteStudioEnabled = (): boolean => {
  const enabled = Boolean(useMe()?.company?.companySettings?.routeStudioEnabled)
  const { roles } = useReactiveVar(routingVar)
  return enabled && !roles.includes('hauler')
}
